/* vh life — unified header: mobile menu toggle + close on click. */
(function () {
  "use strict";
  function wire(hdr) {
    if (hdr.__wired) return;
    hdr.__wired = true;
    var btn = hdr.querySelector(".vh-hdr__burger");
    var nav = hdr.querySelector(".vh-hdr__nav");
    if (!btn || !nav) return;
    var close = function () { hdr.classList.remove("is-open"); btn.setAttribute("aria-expanded", "false"); };
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = hdr.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", close); });
    document.addEventListener("click", function (e) { if (!hdr.contains(e.target)) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    // Open the native cart drawer directly. The theme's own aria-controls click
    // delegate (used by the base header) did not reliably catch clicks from this
    // custom header in testing, so this calls the drawer's show() method directly
    // as a guaranteed-working fallback — same drawer, same markup, just triggered
    // explicitly instead of relying on the undocumented delegate scoping. show()
    // must run outside this handler's own synchronous dispatch (confirmed by
    // testing: calling it inline silently no-ops, a setTimeout(0) defer works),
    // so it's deferred by one tick.
    var cartLink = hdr.querySelector(".vh-hdr__cart");
    if (cartLink && cartLink.hasAttribute("aria-controls")) {
      cartLink.addEventListener("click", function (e) {
        var drawer = document.getElementById(cartLink.getAttribute("aria-controls"));
        if (drawer && typeof drawer.show === "function") {
          e.preventDefault();
          setTimeout(function () { drawer.show(); }, 0);
        }
      });
    }

    // Keep the header cart badge in sync with real cart state. Fetches /cart.js instead of
    // trusting the add-to-cart response's own item count, so this stays correct regardless
    // of which code path triggered the change (PDP add-to-cart, sticky ATC, future flows).
    // Elevation shadow once scrolled, plus the offer/claim crossfade past its own
    // threshold — single passive listener, rAF-throttled. The claim pill's tabindex
    // tracks visibility so keyboard users never land on an invisible control.
    var claim = hdr.querySelector("[data-vh-hdr-claim]");
    var offerEnabled = hdr.hasAttribute("data-offer-enabled");
    var offerThreshold = parseInt(hdr.getAttribute("data-offer-threshold"), 10) || 560;
    var scrollTick = false;
    var onScroll = function () {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(function () {
        hdr.classList.toggle("is-scrolled", window.scrollY > 4);
        if (offerEnabled) {
          var showOffer = window.scrollY > offerThreshold;
          hdr.classList.toggle("is-offer", showOffer);
          if (claim) claim.setAttribute("tabindex", showOffer ? "0" : "-1");
        }
        scrollTick = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    var badge = hdr.querySelector(".vh-hdr__cart-count");
    if (badge) {
      document.addEventListener("cart:change", function () {
        fetch("/cart.js")
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            badge.textContent = cart.item_count;
            if (cart.item_count > 0) badge.removeAttribute("data-empty");
            else badge.setAttribute("data-empty", "");
          });
      });
    }
  }
  function init() { document.querySelectorAll("[data-vh-header]").forEach(wire); }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
